const postStudioAvailabilityPayload = (formField) => {
  const payload = { name: formField?.name };

  return payload;
};

export default postStudioAvailabilityPayload;
